import { render, staticRenderFns } from "./TotalUSCovidCases.vue?vue&type=template&id=1400b5e7&"
import script from "./TotalUSCovidCases.vue?vue&type=script&lang=js&"
export * from "./TotalUSCovidCases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports